/**
 * 请求管理器
 * 提供基础的HTTP请求方法和请求实例管理
 */
import axios from 'axios';
import { currentEnv } from '@/qingyu/config/config-core';
import UserRequest from './modules/user';
import SystemRequest from './modules/system';
import ReportRequest from './modules/report';
import ServiceRequest from './modules/ServiceRequest';
import ParkRequest from './modules/park';

// 创建axios实例
const instance = axios.create({
  baseURL: currentEnv.baseURL,
  timeout: currentEnv.timeout,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

// 基础请求方法
export function get(url, params) {
  return instance.get(url, { params });
}

export function post(url, data) {
  return instance.post(url, data);
}

export function put(url, data) {
  return instance.put(url, data);
}

export function del(url, params) {
  return instance.delete(url, { params });
}

// 请求实例管理器
class RequestManager {
  constructor() {
    this.user = new UserRequest();
    this.system = new SystemRequest();
    this.report = new ReportRequest();
    this.service = new ServiceRequest();
    this.park = new ParkRequest();
  }

  // 重置所有请求实例
  reset() {
    this.user = new UserRequest();
    this.system = new SystemRequest();
    this.report = new ReportRequest();
    this.service = new ServiceRequest();
    this.park = new ParkRequest();
  }
}

// 创建单例实例并导出
const requestManager = new RequestManager();
export default requestManager; 